const emptyState = {
  user: {
    user: "",
    last_update: "2019-11-16 19:52:16.000000",
  },
};

const getInitialState = () => {
  if (typeof window === "undefined") return emptyState;

  try {
    const storedUser = window.sessionStorage.getItem("beesqlUserSession");
    return storedUser ? { user: JSON.parse(storedUser) } : emptyState;
  } catch (_) {
    window.sessionStorage.removeItem("beesqlUserSession");
    return emptyState;
  }
};

const initState = getInitialState();

const userReducer = (state = initState, action) => {
  switch (action.type) {
    case "SET_USER":
      return { ...state, user: action.payload };
    case "CLEAR_SESSION":
    case "USER_LOGOUT":
      return emptyState;
    default:
      return state;
  }
};

export default userReducer;
